export default {
  "content": "<path d=\"M13.5 18.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11 4.5h2V15h-2V4.5z\" fill=\"#7B61FF\"/><path d=\"M8.991 16.492L7.76 15.26a5.956 5.956 0 011.231-.954v2.186zM15.001 14.306c.448.26.865.58 1.24.954l-1.232 1.232L15 14.306zM8.998 12.08a7.962 7.962 0 00-2.658 1.76l-1.41-1.41a9.945 9.945 0 014.068-2.467v2.117zM14.998 9.963a9.91 9.91 0 014.062 2.467l-1.41 1.41a7.962 7.962 0 00-2.659-1.76l.007-2.117zM8.99 7.878a11.973 11.973 0 00-5.48 3.132L2.1 9.6a13.915 13.915 0 016.89-3.777v2.055zM15.009 5.823a13.915 13.915 0 016.89 3.777l-1.41 1.41a11.973 11.973 0 00-5.48-3.132V5.823z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};